// extracted by mini-css-extract-plugin
export default {"container":"PriceRiseCalculator_container__HjQat"};